import { RunnerTypes } from "app/utils/const";
import cx from "classnames";
import type { Element } from "React";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { TranslationHelper } from "../../helpers/translationHelper";
import type { EventIncidentType } from "../../types/eventType";
import { DangerZoneStates } from "../../utils/const";
import DangerZoneArrows from "./components/DangerZoneArrows/DangerZoneArrows";
import "./DangerZone.scss";
type Props = {
  eventIncident: EventIncidentType;
  className?: string;
};

class DangerZone extends Component<Props> {
  render(): null | Element<"div"> {
    const { eventIncident, className } = this.props;
    let incidentType = null;
    const dangerZoneState =
      eventIncident != null ? eventIncident["dangerballStatus"] : "";

    // check if incident type should override danger status
    if (eventIncident.type != null) {
      if (
        eventIncident.type.includes("GOAL") ||
        eventIncident.type.includes("CORNER") ||
        eventIncident.type.includes("YELLOW") ||
        eventIncident.type.includes("RED")
      ) {
        incidentType = eventIncident.type;
      }
    }

    // Only render the component if
    // danger zone state is not SAFE
    if (
      eventIncident == null || // dangerZoneState === DangerZoneStates.SAFE ||
      (dangerZoneState === DangerZoneStates.MISSED_INCIDENT &&
        incidentType === null)
    ) {
      return null;
    } else if (
      dangerZoneState === DangerZoneStates.SAFE &&
      incidentType === null
    ) {
      return null;
    }

    const isHome = dangerZoneState.includes(RunnerTypes.HOME);
    const isAway = dangerZoneState.includes(RunnerTypes.AWAY);
    return (
      <div
        className={cx(
          "danger-zone",
          {
            "danger-zone--home": isHome,
            "danger-zone--away": isAway,
          },
          className
        )}
      >
        <FormattedMessage
          tagName="span"
          id={
            incidentType === null
              ? TranslationHelper.getTranslationIdForDangerZone(dangerZoneState)
              : TranslationHelper.getTranslationIdForIncidentType(incidentType)
          }
        />
        <DangerZoneArrows
          className="danger-zone__arrows"
          pointingRight={isHome}
        />
      </div>
    );
  }
}

export default DangerZone;
